export const API_KEYS_PROJECT_LIMIT = 10;
export const API_KEYS_ACCOUNT_LIMIT = 10;
export const QUOTA_LIMIT = 15000;
export const ACCOUNT_QUOTA_LIMIT = 700000;
//# sourceMappingURL=api-key.limits.js.map